import { ContaBancariaDto } from '../dto/DetalheOfertaDto';

class ContaBancariaResource {
  nomeInstituicaoFinanceira: string;
  agencia: string;
  conta: string;

  constructor(dto: ContaBancariaDto) {
    this.nomeInstituicaoFinanceira = dto.nomeInstituicaoFinanceira;
    this.agencia = dto.agencia;
    this.conta = dto.conta;
  }
}

export default ContaBancariaResource;
